import { Checkbox, Flex } from 'antd';
import { format, isToday } from 'date-fns';
import parse from 'html-react-parser';

interface SentMessageTabProps {
  title: string;
  read?: boolean;
  active?: boolean;
  message: string;
  onClick: () => void;
  modified: Date | undefined;
  checked: boolean;
  handleSelect: (checked: boolean) => void;
}

export function SentMessageTab({
  title,
  read = false,
  active = false,
  message,
  onClick,
  modified,
  checked,
  handleSelect,
}: SentMessageTabProps) {
  const today = modified && isToday(new Date(modified));

  return (
    <Flex
      className={`message-list-item sent ${read ? 'read' : ''} ${active ? 'active' : ''}`}
    >
      <div className="message-list-item__indicator">
        <Checkbox
          checked={checked}
          onChange={(e) => handleSelect(e.target.checked)}
          aria-label={`Select message to ${title}`}
        />
      </div>
      <Flex vertical className="message-list-item__details" onClick={onClick}>
        <Flex align="center" justify="space-between" className="to">
          <div className="to__name">
            To: <span className="fw-bold">{title}</span>
          </div>
          <div className="to__time">
            {today ? (
              <div className="from__time">
                {format(new Date(modified), 'h:mm a')}
              </div>
            ) : (
              <div className="from__time">
                {new Date(modified ?? '').toLocaleString()}
              </div>
            )}
          </div>
        </Flex>
        <div className="desc message-box-img">{parse(message)}</div>
      </Flex>
    </Flex>
  );
}
